import { officialLanguages } from './logto-catalog';

/** Product-supported languages, shared by the portal, sign-in and account center. */
const supportedCodes = new Set(['zh', 'zh-TW', 'en', 'ja', 'ko', 'fr', 'de', 'es', 'pt']);
export const platformLanguages = officialLanguages
  .filter(({ code }) => supportedCodes.has(code))
  .map((item) => ({ ...item, label: item.label.replace(/\s*[（(].*?[）)]/g, '').trim() }));
export type PlatformLanguage = (typeof platformLanguages)[number]['code'];

export function matchPlatformLanguage(raw?: string | null) {
  for (const value of raw?.trim().replaceAll('_', '-').split(/\s+/) ?? []) {
    let tag: string;
    try {
      tag = Intl.getCanonicalLocales(value)[0]?.toLowerCase() ?? '';
    } catch {
      continue;
    }
    const exact = platformLanguages.find((item) => item.tag.toLowerCase() === tag);
    if (exact) return exact;
    // Script/region preferences must not collapse all Chinese or Portuguese variants.
    const alias = tag.startsWith('zh-hant')
      ? 'zh-TW'
      : tag === 'zh-mo' || tag === 'zh-hk'
        ? 'zh-TW'
        : tag.startsWith('zh-hans')
          ? 'zh-CN'
          : tag === 'es-419'
            ? 'es'
            : undefined;
    if (alias) return platformLanguages.find((item) => item.tag === alias);
    const base = tag.split('-')[0];
    const match =
      platformLanguages.find((item) => item.code === base) ??
      platformLanguages.find((item) => item.tag.toLowerCase().split('-')[0] === base);
    if (match) return match;
  }
}

export function nativeLanguage(raw: string) {
  return matchPlatformLanguage(raw)?.native ?? 'en';
}

export function languageDirection(raw: string): 'ltr' | 'rtl' {
  const tag = matchPlatformLanguage(raw)?.tag;
  return tag === 'ar' || tag === 'fa-IR' ? 'rtl' : 'ltr';
}
